import {FileMetaData} from "./FileMetaData";
import {Plant} from "./Plant";

export class Company {
  companyId?: number;
  companyName?: string;
  languageId?: number;
  isClone?: boolean;
  doNotShare?: boolean;
  companyLogo?: FileMetaData;
  plants?: Array<Plant>;
  createdDate?: number
  createdUser?: string;
  modifiedDate?: number;
  modifiedUser?: string;

  static getClientLogoUrl(client : Company) {
    if(client.companyLogo) {
      return client.companyLogo.fileURL;
    }

    return '';
  }

  static getClientLogoId(client : Company) {
    if(client.companyLogo) {
      return client.companyLogo.fileId;
    }

    return '';
  }
}
